import { render, staticRenderFns } from "./PlantillasCards.vue?vue&type=template&id=6bc94536&scoped=true"
import script from "./PlantillasCards.vue?vue&type=script&lang=js"
export * from "./PlantillasCards.vue?vue&type=script&lang=js"
import style0 from "./PlantillasCards.vue?vue&type=style&index=0&id=6bc94536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc94536",
  null
  
)

export default component.exports